import {getAccountLabel} from '../../../common/utils/accounts'
import {getPammMoneyManagerInfo} from '../PammMoneyManagerPill'
import {Account, Client} from '../../../graphql/types'

export const isAccount = (account: Account | Client): account is Account => 'remoteId' in account && 'balance' in account

export const isClient = (account: Account | Client): account is Client => 'firstName' in account

export const getLabel = (suggestion: Account | Client, locale: string): string => {
  // The money manager is part of what the option shows for PAMM accounts, so it
  // has to be searchable too — that is the whole point of showing it (PT-5768).
  // Same predicate as the pill, so nothing is findable that isn't displayed.
  if (isAccount(suggestion)) {
    const moneyManagerInfo = getPammMoneyManagerInfo(suggestion)
    const moneyManager = moneyManagerInfo ? ` ${moneyManagerInfo.name} ${moneyManagerInfo.id}` : ''
    return `${getAccountLabel(suggestion, locale)} ${suggestion.remoteId} ${suggestion.balance}${moneyManager}`
  }
  if (isClient(suggestion)) return `${suggestion.firstName} ${suggestion.lastName} ${suggestion.id}`
  return 'Unknown'
}
